// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrAddressResponseDto } from './IOcrAddressResponseDto';
import {
    IOcrAddressResponseDtoFromJSON,
    IOcrAddressResponseDtoFromJSONTyped,
    IOcrAddressResponseDtoToJSON,
    IOcrAddressResponseDtoToJSONTyped,
} from './IOcrAddressResponseDto';

/**
 * 
 * @export
 * @interface IOcrSuggestedProviderDto
 */
export interface IOcrSuggestedProviderDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrSuggestedProviderDto
     */
    provider_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrSuggestedProviderDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrSuggestedProviderDto
     */
    tax_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrSuggestedProviderDto
     */
    is_new_provider?: boolean;
    /**
     * 
     * @type {Array<IOcrAddressResponseDto>}
     * @memberof IOcrSuggestedProviderDto
     */
    addresses?: Array<IOcrAddressResponseDto>;
}

/**
 * Check if a given object implements the IOcrSuggestedProviderDto interface.
 */
export function instanceOfIOcrSuggestedProviderDto(value: object): value is IOcrSuggestedProviderDto {
    return true;
}

export function IOcrSuggestedProviderDtoFromJSON(json: any): IOcrSuggestedProviderDto {
    return IOcrSuggestedProviderDtoFromJSONTyped(json, false);
}

export function IOcrSuggestedProviderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrSuggestedProviderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'is_new_provider': json['is_new_provider'] == null ? undefined : json['is_new_provider'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(IOcrAddressResponseDtoFromJSON)),
    };
}

export function IOcrSuggestedProviderDtoToJSON(json: any): IOcrSuggestedProviderDto {
    return IOcrSuggestedProviderDtoToJSONTyped(json, false);
}

export function IOcrSuggestedProviderDtoToJSONTyped(value?: IOcrSuggestedProviderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider_id': value['provider_id'],
        'name': value['name'],
        'tax_id': value['tax_id'],
        'is_new_provider': value['is_new_provider'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(IOcrAddressResponseDtoToJSON)),
    };
}

